import React from 'react';
import './TabPanel.css';
import Tab from './Tab.js';
import logComponent from '../../common/logComponent';

export default function TabPanel({ children, currentPanel, style }) {
  if (logComponent('TabPanel')) { console.debug('TabPanel rendered'); }
  return (
    <div className="TabPanel">
      {
        currentPanel !== 'Modules' &&
        <h2 className="TabPanel__tab--selected--sm">{currentPanel}</h2>
      }
      <ul className="TabPanel__tabs">
        {children
          .filter(child => !child.props.hideIf)
          .map((child, index) => {
            return <li
              className={'TabPanel__tab' + (currentPanel === child.props.title ? ' TabPanel__tab--selected' : '')}
              style={currentPanel === child.props.title && style && style.selectedTab ? style.selectedTab : {}}
              key={child.props.title}
            >
              <Tab title={child.props.title} linkPath={child.props.linkPath}>{child.props.title}</Tab>
            </li>

          }
          )
        }
      </ul>
      <div className="TabPanel__panels">
        {children
          .filter(child => !child.props.hideIf && currentPanel === child.props.title)
          .map(child =>
            <div
              className="TabPanel__panel"
              key={child.props.title}>{child}</div>
          )
        }
      </div>
    </div>
  );
}